var LinksService = /** @class */ (function () {
    function LinksService() {
        this.links = [
            { href: ['/'], name: 'Hoofdpagina', short_name: 'Home' },
            { href: ['/visie-en-missie'], name: 'Visie en missie', short_name: 'Visie' },
            { href: ['/contact'], name: 'Contact' },
            { href: ['/projecten'], name: 'Projecten' }
            // { href: ['/evenementen'], name: 'Evenementen' }
        ];
    }
    return LinksService;
}());
export { LinksService };
//# sourceMappingURL=links.service.js.map